<template>
  <li v-if="$store.state.isLoggedIn" class="user-auth tooltip-holder">
    <a :class="background" href="#" @click="showUserInfo = !showUserInfo">Hi, {{$store.state.username}}</a>
    <div v-if="showUserInfo" class="login-tooltip">
      Hi, {{$store.state.username}}&nbsp;&nbsp;&nbsp;&nbsp;<button class="sign-out" @click="signOut">Sign Out</button>
    </div>
    <div v-if="showUserInfo" class="login-tooltip-bg" @click="showUserInfo = false">
    </div>
  </li>
  <li v-else class="user-auth" @click="$store.commit('LOGIN_REQUESTED')">
    <a :class="background" href="#">Sign In</a>
    <span :class="background" style="margin: 0 2px;">/</span>
    <a :class="background" href="#">Sign Up</a>
  </li>
</template>
<script>
export default {
  name: 'LoginLogout',
  props: ['background'],
  data () {
    return {
      showUserInfo: false
    }
  },
  methods: {
    signOut () {
      this.showUserInfo = false
      this.$store.dispatch('LOGOUT')
    }
  }
}
</script>
<style scoped>
  .login-tooltip-bg {
    z-index: 998;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.05);
  }
  .login-tooltip {
    top: 26px;
    /*display: none;*/
    right: 15px;
    opacity: 1;
    position: absolute;
    white-space: nowrap;
    z-index: 999;
    transform: translateY(10px);
    transition: all 0.25s ease-out;
    background-color: #ffffff;
    box-shadow: 3px -1px 4px 0 rgba(76, 76, 76, 0.46);
    border: solid 1px #c6c6c6;
    font-size: 16px;
    line-height: 20px;
    padding: 15px;
    border-radius: 3px;
    text-align: left;
  }

  .sign-out {
    color: #007EE5;
    height: 28px;
    width: 120px;
    border: 1px solid #007EE5;
    border-radius: 14.5px;
    background-color: #FFFFFF;
    box-shadow: 1px 1px 2px 0 rgba(0,0,0,0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginLogout.vue